import React from "react";

import "./Intro.scss";

interface IntroProps {
  onDismiss: () => void;
}
export const Intro: React.FC<IntroProps> = ({ onDismiss }) => (
  <div className="intro">
    <p>Please put on your headphones</p>
    <button className="button button--small button--auto" onClick={onDismiss}>Begin</button>
  </div>
);
